define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext", "../../models/UserModel", "../../models/RoleModel"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext, UserModel, RoleModel) {
    "use strict";
    var Users = /** @class */ (function () {
        function Users() {
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,Users.Edit,Users.Delete"));
            this.userCanDelete = ko.observable(UserContext.hasAccess("Admin,Users.Delete"));
            this.twoFactorTypes = [
                { Value: "GoogleAuthenticator", Text: "Google Authenticator" },
                { Value: "PhoneCode", Text: "Phone Code" },
                { Value: "EmailCode", Text: "Email Code" }
            ];
            this.filterByServer = ko.observable("");
            this.clearFilterInProgress = false;
            this.filterByAny = ko.observable("");
            this.editModel = ko.observable(new UserModel());
            this.roleModel = ko.observable(new RoleModel());
            this.roleModelTable = ko.observableArray();
            this.helpScoutUsers = ko.observableArray();
            this.roleGroups = ko.observableArray();
            this.binded = false;
        }
        Users.prototype.init = function () {
            var self = this;
            $("#page-title").text("Users");
            tools.ajaxGet({
                url: "/Users/GetUsersLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.usersLookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    $(".js-new-user").on("click", function (event) {
                        self.editUser();
                        event.preventDefault();
                    });
                    self.initUsers(self.usersLookupLists.GridStructures.UserStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        Users.prototype.initUsers = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "150px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    if (dataItem.Id !== 1) {
                        html += '<div class="user-actions">';
                        if (self.userCanEdit()) {
                            html += '<a class="btn btn-info btn-edit btn-sm" title="Edit" href="#"><i class="fa fa-edit " ></i></a>';
                            //html += '&nbsp;<a class="btn btn-yellow btn-roles btn-sm" title="Roles" href="#"><i class="fa fa-user"></i></a>';
                            html += '&nbsp;<a class="btn btn-info btn-password btn-sm" title="Change Password" href="#"><i class="fa fa-key"></i></a>';
                            if (dataItem.isLocked) {
                                html += '&nbsp;<a class="btn btn-warning btn-lock btn-sm" title="Unlock" href="#"><i class="fa fa-unlock"></i></a>';
                            }
                            else {
                                html += '&nbsp;<a class="btn btn-warning btn-lock btn-sm" title="Lock" href="#"><i class="fa fa-lock"></i></a>';
                            }
                        }
                        if (self.userCanDelete()) {
                            html += '&nbsp;<a class="btn btn-danger btn-remove btn-sm" title="Delete" href="#"><i class="fa fa-trash-o"></i></a>';
                        }
                        if (UserContext.hasAccess("Admin")) {
                            html += '&nbsp;<a class="btn btn-success btn-log btn-sm" title="Login Log" href="#"><i class="fa fa-bars"></i></a>';
                        }
                        html += "</div>";
                    }
                    return html;
                }
            });
            var gridId = "tblUsersKendo";
            self.usersTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                gridOptions: {
                    columns: columns,
                    toolbar: kendo.template($("#u-toolbar-template").html()),
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row menu",
                        extra: false
                    },
                    dataBound: function () {
                        self.clearFilterInProgress = false;
                        $(".k-grid-content .user-actions .btn").kendoTooltip({
                            position: "top"
                        }).data("kendoTooltip");
                    }
                },
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Users/GetUsers",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        },
                        parameterMap: function (options) {
                            if (options.filter && options.filter.filters) {
                                ko.utils.arrayForEach(options.filter.filters, function (item) {
                                    if (item.value instanceof Date) {
                                        item.value = kendo.toString(item.value, "d");
                                    }
                                });
                            }
                            return options;
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                enableExport: {
                    entityName: "User",
                    title: "Users",
                    enablePdf: false
                },
                gridId: gridId,
                showPagerOnTop: false,
                controller: self
            };
            self.usersTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                if (!self.clearFilterInProgress) {
                    self.usersTable.refresh();
                }
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.editUser(data.Id);
                event.preventDefault();
            }).on("click", ".btn-roles", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.userRoles(data.Id);
                event.preventDefault();
            }).on("click", ".btn-password", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.changeUserPassword(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.deleteUserConfirm(data);
                event.preventDefault();
            }).on("click", ".btn-lock", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.toggleUserIsLock(data);
                event.preventDefault();
            }).on("click", ".btn-log", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                var dataLogs = new DataLogs("Login", dataItem.Id);
                dataLogs.open("Login logs: " + dataItem.Login);
                event.preventDefault();
            }).on("click", ".btn-logout", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                $(event.currentTarget).remove();
                self.forceFullLogOut(data);
                event.preventDefault();
            });
        };
        Users.prototype.deleteUserConfirm = function (user) {
            var self = this;
            if (user.Id === 1) {
                tools.error("'Default' user can not be deleted");
                return;
            }
            tools.confirmModal({
                title: "Delete user: " + user.Login,
                text: "Are you sure you want to delete this user ?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteUser(user.Id);
            });
        };
        Users.prototype.deleteUser = function (userId) {
            var self = this;
            var data = {
                id: userId
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Users/DeleteUserConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("User deleted successfully");
                    self.usersTable.refresh();
                }
            });
        };
        Users.prototype.forceFullLogOut = function (user) {
            var self = this;
            var data = { userId: user.Id };
            $.ajax({
                url: "/Users/markUserAsLogOut",
                type: "GET",
                data: data,
                success: function () {
                    self.usersTable.refresh();
                }
            });
        };
        Users.prototype.toggleUserIsLock = function (user) {
            var self = this;
            var data = { userId: user.Id };
            $.ajax({
                url: "/Users/ToggleUserIsLock",
                type: "GET",
                data: data,
                success: function () {
                    self.usersTable.refresh();
                }
            });
        };
        Users.prototype.editUser = function (userId) {
            var self = this;
            var title = userId > 0 ? "Edit User" : "Add User";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    if (userId <= 0 && !self.editModel().Login()) {
                        tools.error("Username (email) is required");
                        return;
                    }
                    //validate form
                    if (!self.editModel().EMail()) {
                        tools.error("Email is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveUser(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (userId > 0) {
                        getModelCall = tools.ajaxGet({
                            url: "/Users/GetUserById",
                            data: { id: userId },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new UserModel(result.Data));
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new UserModel());
                    }
                    var getlookupData = tools.ajaxGet({
                        url: "/Users/GetUserLookupData",
                        success: function (data) {
                            if (data.Success) {
                                self.helpScoutUsers(data.Data.lookupLists.HelpScoutUsers);
                                self.roleGroups(data.Data.lookupLists.Roles);
                            }
                        }
                    });
                    $.when(getModelCall, getlookupData).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'user-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        Users.prototype.saveUser = function (btn, modal) {
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Users/SaveUser",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.usersTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        Users.prototype.changeUserPassword = function (userId) {
            var self = this;
            var title = "Change Password Form";
            tools.editModal({
                title: title,
                buttonTitle: "Change Password",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    var obj = ko.mapping.toJS({
                        NewPassword: self.editModel().NewPassword,
                        ConfirmPassword: self.editModel().ConfirmPassword
                    });
                    if (!obj.NewPassword) {
                        tools.error("Please enter a password.");
                        return;
                    }
                    if (!tools.isValidPassword(obj.NewPassword)) {
                        return;
                    }
                    if (obj.NewPassword !== obj.ConfirmPassword) {
                        tools.error("The confirmation password does not match.");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveUserPassword(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(userId)) {
                        getModelCall = tools.ajaxGet({
                            url: "/Users/GetUserById",
                            data: { id: userId },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new UserModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new UserModel());
                    }
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'user-change-password-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        Users.prototype.saveUserPassword = function (btn, modal) {
            var self = this;
            var obj = {
                Id: self.editModel().Id(),
                OldPassword: "",
                NewPassword: self.editModel().NewPassword(),
                ConfirmPassword: self.editModel().ConfirmPassword()
            };
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Users/ChangeUserPassword",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    if (result.Data) {
                        tools.success("Password changed successfully");
                    }
                    else {
                        tools.error("Password change failed");
                    }
                    $(modal).modal("hide");
                    return;
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        Users.prototype.userRoles = function (userId) {
            var self = this;
            var title = "User Roles";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalClass: "full-width",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.saveUserRoles(event.currentTarget, modal, userId);
                },
                opened: function (modal) {
                    self.roleModelTable.removeAll();
                    var getModelCall = tools.ajaxPost({
                        url: "/Users/GetRoles",
                        data: { userId: userId }
                    }).done(function (result) {
                        var i, j;
                        var parentTemp = "";
                        var countRadios = 0;
                        if (result && result.Data) {
                            result.Data.sort(function (a, b) {
                                if (a.Parent < b.Parent)
                                    return -1;
                                else if (a.Parent > b.Parent)
                                    return 1;
                                var child1 = a.Child === "View" ? 0
                                    : (a.Child === "Add" || a.Child === "Edit") ? 1
                                        : a.Child === "Delete" ? 2 : 3;
                                var child2 = b.Child === "View" ? 0
                                    : (b.Child === "Add" || b.Child === "Edit") ? 1
                                        : b.Child === "Delete" ? 2 : 3;
                                return child1 - child2;
                            });
                            var childTemp = "";
                            var arrayTemp = [];
                            var firstTemp = undefined;
                            for (i = 0; i < result.Data.length; i++) {
                                if (parentTemp !== result.Data[i].Parent) {
                                    firstTemp = new RoleModel(result.Data[i]);
                                    firstTemp.RadioValue = null;
                                    arrayTemp = [firstTemp];
                                    self.roleModelTable.push(arrayTemp);
                                    parentTemp = result.Data[i].Parent;
                                    childTemp = result.Data[i].Child;
                                    if (result.Data[i].UserSelected) {
                                        firstTemp.RadioValue = result.Data[i].Child;
                                    }
                                }
                                else if ((childTemp === "View" || childTemp === "Edit" || childTemp === "Delete" || childTemp === "Add") &&
                                    (result.Data[i].Child === "View"
                                        || result.Data[i].Child === "Edit"
                                        || result.Data[i].Child === "Delete"
                                        || result.Data[i].Child === "Add")) {
                                    arrayTemp.push(new RoleModel(result.Data[i]));
                                    if (result.Data[i].UserSelected) {
                                        firstTemp.RadioValue = result.Data[i].Child;
                                        continue;
                                    }
                                    else if (firstTemp.RadioValue == null) {
                                        firstTemp.RadioValue = "None";
                                    }
                                }
                                else {
                                    self.roleModelTable.push([new RoleModel(result.Data[i])]);
                                    parentTemp = result.Data[i].Parent;
                                    childTemp = result.Data[i].Child;
                                }
                            }
                            var sourceTable = ko.mapping.toJS(self.roleModelTable);
                            self.roleModelTable.removeAll();
                            parentTemp = "";
                            var tempArray = [];
                            for (i = 0; i < sourceTable.length; i++) {
                                if (parentTemp === sourceTable[i][0].Parent || parentTemp === "") {
                                    countRadios = 0;
                                    for (j = 0; j < sourceTable[i].length; j++) {
                                        if (sourceTable[i][j].Child === "View" ||
                                            sourceTable[i][j].Child === "Add" ||
                                            sourceTable[i][j].Child === "Edit" ||
                                            sourceTable[i][j].Child === "Delete") {
                                            countRadios++;
                                        }
                                    }
                                    for (j = 0; j < sourceTable[i].length; j++) {
                                        if ((sourceTable[i][j].Child === "View" ||
                                            sourceTable[i][j].Child === "Add" ||
                                            sourceTable[i][j].Child === "Edit" ||
                                            sourceTable[i][j].Child === "Delete") &&
                                            countRadios > 1) {
                                            sourceTable[i][j].IsRadio = true;
                                        }
                                        else {
                                            sourceTable[i][j].RadioValue = null;
                                        }
                                        tempArray.push(new RoleModel(sourceTable[i][j]));
                                    }
                                }
                                else {
                                    self.roleModelTable.push(tempArray);
                                    tempArray = [];
                                    countRadios = 0;
                                    for (j = 0; j < sourceTable[i].length; j++) {
                                        if (sourceTable[i][j].Child === "View" ||
                                            sourceTable[i][j].Child === "Add" ||
                                            sourceTable[i][j].Child === "Edit" ||
                                            sourceTable[i][j].Child === "Delete") {
                                            countRadios++;
                                        }
                                    }
                                    for (j = 0; j < sourceTable[i].length; j++) {
                                        if ((sourceTable[i][j].Child === "View" ||
                                            sourceTable[i][j].Child === "Add" ||
                                            sourceTable[i][j].Child === "Edit" ||
                                            sourceTable[i][j].Child === "Delete") &&
                                            countRadios > 1) {
                                            sourceTable[i][j].IsRadio = true;
                                        }
                                        else {
                                            sourceTable[i][j].RadioValue = null;
                                        }
                                        tempArray.push(new RoleModel(sourceTable[i][j]));
                                    }
                                }
                                if (i === (sourceTable.length - 1)) {
                                    self.roleModelTable.push(tempArray);
                                }
                                else {
                                    parentTemp = sourceTable[i][0].Parent;
                                }
                            }
                        }
                    });
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'user-roles-template', data: roleModelTable }\"></div>");
                        ko.applyBindings(self, modal);
                        $("checkbox,radio,label", modal).kendoTooltip({
                            position: "top"
                        }).data("kendoTooltip");
                    });
                }
            });
        };
        Users.prototype.saveUserRoles = function (btn, modal, userId) {
            var self = this;
            var i, j;
            var obj = ko.mapping.toJS(self.roleModelTable);
            var resultObject = [];
            var radioTempValue = null;
            for (i = 0; i < obj.length; i++) {
                if (obj[i][0].IsRadio && obj[i][0].RadioValue != null) {
                    radioTempValue = obj[i][0].RadioValue;
                }
                for (j = 0; j < obj[i].length; j++) {
                    if (obj[i][j].IsRadio) {
                        if (obj[i][j].Child === radioTempValue) {
                            obj[i][j].UserSelected = true;
                            radioTempValue = null;
                        }
                        else {
                            if (radioTempValue == null || radioTempValue === "None") {
                                obj[i][j].UserSelected = false;
                            }
                            else {
                                obj[i][j].UserSelected = true;
                            }
                        }
                    }
                }
            }
            for (i = 0; i < obj.length; i++) {
                for (j = 0; j < obj[i].length; j++) {
                    resultObject.push(obj[i][j]);
                }
            }
            var data = { roles: JSON.stringify(resultObject), userId: userId };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Users/SetRoles",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    $(modal).modal("hide");
                    return;
                }
            }).always(function () {
                $(btn).button("reset");
            });
            $(modal).modal("hide");
            return;
        };
        Users.prototype.exportTo = function () {
            var self = this;
            self.usersTable.exportTo();
        };
        Users.prototype.clearFilter = function () {
            var self = this;
            self.clearFilterInProgress = true;
            self.filterByAny("");
            setTimeout(function () {
                self.usersTable.refresh();
            }, 201);
        };
        Users.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("User");
                dataLogs.open("User logs");
                event.preventDefault();
            }
        };
        Users.prototype.getUsersLookup = function (externalId) {
            var self = this;
            tools.ajaxGet({
                url: "/Users/GetHelpScoutUsers",
                data: { externalId: externalId },
                success: function (data) {
                    if (data.Success) {
                        self.helpScoutUsers.remove(function () { return true; });
                        for (var i = 0; i < data.Data.length; i++) {
                            var item = data.Data[i];
                            self.helpScoutUsers.push(item);
                        }
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
        };
        return Users;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Users/Configurations")) {
            log.log("Initialize Users list");
            $(function () {
                (new Users()).init();
            });
        }
    }, 0);
    return Users;
});
//# sourceMappingURL=users.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/users/users.js
// module id = 271
// module chunks = 2